import React, {useEffect, useState} from 'react';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import './forget-password.scss';
import { publicRequest } from '../../api/apiConfig/publicRequest';
import { showErrorNotification, showSuccessNotification } from '../../customHooks';
import { useDispatch } from 'react-redux';

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
    const navigate = useNavigate()

  const handleChange = (e) => {
    setEmail(e.target.value)
        }
        
  const handleLoginSubmit = async (e) => {

    e.preventDefault();
    try {
      await publicRequest.post('/auth/forgot-pass', { email: email });
      showSuccessNotification("Email was sent successfully")
      navigate('/')

    } catch (error) {
      showErrorNotification(error.response.data.errorMessage);
    }
  }


  const resetInputField = () => {
    setEmail("");
  };

  useEffect(() => {
    
  
    return () => {
      
    }
  }, [])
  

  return (

    <div className="creat-box">
      <form
        className='Forget_firstHalf-emailForm'
        onSubmit={handleLoginSubmit}>
        <div className='img'></div>
        <input
        required={true}
        className='email_forget_pass' 
        type="email"
          autoComplete="off" name='email'
          onChange={handleChange}
          value={email}
          placeholder="Enter Email" />
        <div className="Forgetfirst">
          
            <button className="create__Forgetsec--btn"
            type="submit"
            > Submit</button>

      <button className="create__Forgetsec--btn"
            onClick={resetInputField}
            > Clear</button>
          </div>
       
        <div className="ForgetsecondLogin">
          <Link to="/">Log In</Link>
        </div>
      </form>
    </div>

  );
}
export default ForgetPassword;